<template>
    <tl-app>
        <PageLoader />
        <router-view />
        <CommonModal />
        <Toast
            position="bottom-right"
            group="tl"
            append-to="#app"
            :pt="{
                root: { 'data-testid': 'tl-toast', },
                messageContent: { 'data-testid': 'tl-toast-content' },
                closeButton: { 'data-testid': 'tl-toast-close-button' },
            }"
        />
        <GatewayTimeoutToast />
        <div id="widget" />
    </tl-app>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
import PageLoader from '@/components/panel/PageLoader.vue'
import CommonModal from '@/components/atoms/CommonModal.vue'
import GatewayTimeoutToast from './modules/errors/components/GatewayTimeoutToast.vue'
import { useToast } from 'primevue/usetoast'
import { setToastInstance } from '@/composables/notifications/toast-instance'
import { onMounted } from 'vue'

onMounted(() => {
    const toast = useToast()
    setToastInstance(toast)
})
</script>
